<template>
  <div class="agentUser">
    <div class="searchView">
      <div class="searchView__container">
        <span class="searchView__tag">筛选</span>
        <div class="searchInput">
          <input placeholder="输手机号" v-model="phone" />
        </div>
        <span class="searchView__searchBtn" @click="handleSearchEvent()">搜索</span>
        <span class="searchView__searchBtn" @click="refreshListen()">刷新试听上课状态</span>
      </div>
      <div class="orderingView">
        <span :class="`orderingView__item ${ordering_type === 'look'?'orderingView__item--select':''}`" @click="orderingEvent('look')">浏览量</span>
        <span :class="`orderingView__item ${ordering_type === 'listen'?'orderingView__item--select':''}`" @click="orderingEvent('listen')">试听量</span>
        <span :class="`orderingView__item ${ordering_type === 'buy'?'orderingView__item--select':''}`" @click="orderingEvent('buy')">购买量</span>
      </div>
    </div>

    <div class="agentUser__list">
        <table class="agentUser__infoTable">
            <tbody>
                <tr class="agentUser__infoLabel">
                    <th class="agentUser__infoLabel__item">昵称</th>
                    <th class="agentUser__infoLabel__item">代理商</th>
                    <th class="agentUser__infoLabel__item">代理商编号</th>
                    <th class="agentUser__infoLabel__item">浏览量</th>
                    <th class="agentUser__infoLabel__item">试听领取量</th>
                    <th class="agentUser__infoLabel__item">购买量</th>
                    <th class="agentUser__infoLabel__item">试听海报</th>
                    <!-- <th class="agentUser__infoLabel__item">5天课海报</th>
                    <th class="agentUser__infoLabel__item">微博活动海报</th> -->
                </tr>
                <tr :class="`agentUser__infoValue ${(data.length%2===0 && index%2 !== 0) || (data.length%2!==0&&index%2===0)?'agentUser__infoValue--blue':'agentUser__infoValue--white'}`" v-for="(item, index) in data" :key="item.pk">
                    <td class="agentUser__infoValue__item">{{item.owner_info.name}}</td>
                    <td :class="`agentUser__infoValue__item ${(staff.includes(item.owner)) || (item.owner_info && item.owner_info.is_staff === true) ? 'agentUser__infoValue__item--red':'agentUser__infoValue__item--blue'}`" @click="lookListenEvent(tab, item.number)">{{item.owner}}</td>
                    <td class="agentUser__infoValue__item">{{item.number}}</td>
                    <td class="agentUser__infoValue__item">{{item.hits}}</td>
                    <td class="agentUser__infoValue__item">{{item.listen_record_count}}</td>
                    <td class="agentUser__infoValue__item">{{item.order_count}}</td>
                    <td class="agentUser__infoValue__item">
                      <span class="agentUser__button" @click="openPoster(item, 'listen')">打开</span>
                    </td>
                    <!-- <td class="agentUser__infoValue__item">
                      <span class="agentUser__button" @click="openPoster(item, 'five_day')">打开</span>
                    </td>
                    <td class="agentUser__infoValue__item">
                      <span class="agentUser__button" @click="openPoster(item, 'weibo_activity')">打开</span>
                    </td> -->
                </tr>
            </tbody>
        </table>
        <el-pagination background layout="prev, pager, next" :total="total" @current-change="changePage">
      </el-pagination>
    </div>

    <AlertMenu ref="alertMenu">
      <div class="orderingView">
        <span :class="`orderingView__item ${tab === 'listen'?'orderingView__item--select':''}`" @click="lookListenEvent('listen')">试听记录</span>
        <span :class="`orderingView__item ${tab === 'buy'?'orderingView__item--select':''}`" @click="lookListenEvent('buy')">购买记录</span>
        <span :class="`orderingView__item ${tab === 'end_class'?'orderingView__item--select':''}`" @click="lookListenEvent('end_class')">上课记录</span>
      </div>
      <div class="listen_content" @scroll="handleScroll($event)" v-if="tab === 'listen' || tab==='end_class'">
        <div class="listen_item" v-for="(item, index) in listen_data" :key="index">
          <span class="text">{{item.contact}}{{(staff.includes(item.contact)) || (item.contact_info && item.contact_info.is_staff === true) ? "(内部员工)" : null}}</span>
          <span class="text">{{item.contact_info.name}}</span>
          <span class="text">{{item.is_buy===true?'已购买':"已领试听"}}{{item.is_class===true?'/已上课':''}}</span>
          <span class="text">{{item.create_time}}</span>
        </div>
      </div>
      <div class="listen_content" @scroll="handleScroll($event)" v-else-if="tab === 'buy'">
        <div class="listen_item" v-for="(item, index) in buy_data" :key="index">
          <span class="text">{{item.owner}}{{(staff.includes(item.owner)) ? "(内部员工)" : null}}</span>
          <span class="text">{{item.owner_info.name}}</span>
          <span class="text">{{item.amount}}</span>
          <span class="text">{{item.create_time}}</span>
        </div>
      </div>
    </AlertMenu>
    <!-- 弹框海报 -->
    <ChoosePoster ref="choosePoster" :agent_number="current_agent_number" v-model="agent_qrcode_url"/>
    
  </div>
</template>
<script>
import { types as AgentTypes } from "../../store/modules/agentUser";
import { types as UserTypes } from "../../store/modules/user";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import AlertMenu from '../../components/AlertMenu'
import ChoosePoster from '../../components/ChoosePoster'

export default {
  name: "AgentUser",
  components: {
    AlertMenu,
    ChoosePoster
  },
  data() {
    return {
      phone: "",
      pagenum:1,
      ordering_type:'',
      agent_number:'',
      tab:'listen',
      agent_qrcode_url:'',
      current_agent_number:''
    };
  },
  computed: {
    ...mapState({
      data: state => state.agentUser.agent.data,
      total:state => state.agentUser.agent.total_count,
      staff:state => state.agentUser.staff,
      listen_load_more: state => state.agentUser.listen.load_more,
      buy_load_more: state => state.agentUser.buy.load_more,
      temp_agent_info: state => state.user.temp_agent_info
    }),
    ...mapGetters({
      listen_data: AgentTypes.GETTER_LIST_LISTEN_DATA,
      buy_data: AgentTypes.GETTER_LIST_BUY_DATA,
    })
  },
  watch:{
    temp_agent_info(item){
      this.updateDataForAgent(item);
      let tag = this.poster_type;
      let qrcode_url = item.qrcode_data && item.qrcode_data[tag];
      console.log(tag, ":", qrcode_url);
      this.showPoster(qrcode_url);
    }
  },
  created() {},
  methods: {
    ...mapMutations({
      updateDataForAgent: AgentTypes.UPDATE_DATA_FOR_AGENT,
    }),
    ...mapActions({
      fetchData: AgentTypes.FETCH_AGENT_DATA,
      fetchAgentListenData: AgentTypes.FETCH_LISTEN_DATA,
      fetchAgentBuyData:AgentTypes.FETCH_BUY_DATA,
      fetchAgentInfo:UserTypes.FETCH_USER_AGENT_INFO,
      fetchRefreshListenRecord:AgentTypes.FETCH_REFRESH_LISTEN_RECORD,
    }),
    //修改页码
    changePage(val) {
      this.pagenum = val;
      this.handleSearchEvent(val);
    },
    //搜索事件
    handleSearchEvent(page) {
        if(!page){
            this.pagenum = 1;
        }else{
            this.pagenum = page;
        }
        let pagenum = this.pagenum;
        let phone = this.phone;
        this.fetchData({page:pagenum, phone:phone, ordering_type:this.ordering_type});
    },
    //刷新试听上课状态
    refreshListen(){
      this.fetchRefreshListenRecord();
    },
    //排序事件
    orderingEvent(tag){
      this.ordering_type = tag;
      this.fetchData({page:this.pagenum, ordering_type:tag});
    },
    //查看代理商引来的试听记录
    lookListenEvent(type, agent_number){
      // console.log(agent_number);
      this.tab = type;
      if(agent_number){
        this.agent_number = agent_number;
      }
      let number = this.agent_number
      if(type === 'listen'){
        this.fetchAgentListenData({"type":"append", "page_type":"reset", "agent_number":number});
      }else if(type === 'buy'){
        this.fetchAgentBuyData({"type":"append", "page_type":"reset", "agent_number":number});
      }else if(type === 'end_class'){
        this.fetchAgentListenData({"type":"append", "page_type":"reset", "agent_number":number, "is_class":true});
      }
      this.$refs.alertMenu.show();
    },
    //打开海报
    openPoster(item){
      this.current_agent_number = item.number;
      this.$refs.choosePoster.show();
    },
    /*
    // -------------以下废弃
    //打开海报
    openPoster(item, tag){
      this.poster_type = tag;
      let qrcode_url = item.qrcode_data && item.qrcode_data[tag]
      if(qrcode_url){
        console.log("直接打开");
        console.log(tag, ":", qrcode_url);
        this.showPoster(qrcode_url)
      }else{
        console.log("间接打开");
        let username = item.owner;
        let dic = {"username":username}
        this.fetchAgentInfo(dic);
      }
    },
    //生成海报
    showPoster(qrcode_url){
      if(qrcode_url){
        this.agent_qrcode_url = qrcode_url;
        this.$refs.choosePoster.show(qrcode_url);
      }
    },
    */
    //滚动事件
    handleScroll(e) {
      // console.log(e);
      let height = e.target.offsetHeight;
      let scrollHeight = e.target.scrollHeight;
      let scrollTop = e.target.scrollTop;
      // console.log(height, scrollHeight, scrollTop);
      if (scrollHeight <= height + scrollTop + 10) {
        //当内容高度小于可视高度+滚动条的高度时，触发事件
        if (this.tab === "listen" && this.listen_load_more) {
          this.fetchAgentListenData({"type":"append", "page_type":"next", "agent_number":this.agent_number});
          console.log("加载新数据--还有更多数据，到达底部，继续加载新数据");
        } else if(this.tab === 'buy' && this.buy_load_more){
          this.fetchAgentBuyData({"type":"append", "page_type":"next", "agent_number":this.agent_number});
          console.log("加载新数据--还有更多数据，到达底部，继续加载新数据");
        }else if(this.tab === 'end_class' && this.listen_load_more) {
          this.fetchAgentListenData({"type":"append", "page_type":"next", "agent_number":this.agent_number, "is_class":true});
        }else {
          console.log("加载新数据--没有新数据了");
        }
      } else {
        console.log("没到底部");
      }
    },
  },
  mounted() {
    if(this.$route.query.searchOwner){
      this.phone = this.$route.query.searchOwner
      this.handleSearchEvent();
    }else{
      this.phone = '';
      this.fetchData();
    }
  }
};
</script>
<style scoped lang="less">
.agentUser {
  margin-left: 180px;
  padding: 20px;
  width: calc(100% - 220px);

  display: flex;
  flex-direction: column;
  position: relative;
  background-color: #f5f5f5;
}
.searchView {
  background-color: white;
  width: calc(100% - 40px);
  height: 80px;
  border-radius: 10px;
  font-size: 20px;
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.searchView__container{
  display: flex;
  flex-direction: row;
  align-items: center;
}
.searchView__tag {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 18px;
}
.searchView__searchBtn {
  /* width: 70px; */
  height: 35px;
  border-radius: 18px;
  background-color: #5f0aff;
  color: white;
  text-align: center;
  line-height: 35px;
  font-size: 16px;
  cursor: pointer;
  padding: 0 10px;
  margin-right: 15px;
}

.searchInput {
  width: 170px;
  height: 35px;
  margin: 0 15px;

  position: relative;
}
.searchInput input {
  background-color: #ecf3ff;
  border-radius: 18px;
  padding-left: 15px;
  padding-right: 15px;
  height: 100%;
  width: calc(100% - 30px);

  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 14px;
  color: #999999;

  border: none;
}
.orderingView{
  font-size: 16px;
  border: solid 1px #5F0AFF;
  border-radius: 20px;
  background-color: #ecf3ff;
  color: #333333;
  overflow: hidden;
  display: inline-block;
}
.orderingView__item{
  display: inline-block;
  padding: 10px 15px;
  cursor: pointer;
  /* background-color: #ecf3ff; */  
}
.orderingView__item--select{
  background-color:#5F0AFF;
  color: #ffffff;

}
.agentUser__list {
  margin-top: 20px;
  background:rgba(255,255,255,1);
box-shadow:0px 0px 21px 0px rgba(48,115,248,0.1);
border-radius:10px;
padding: 15px;
text-align: center;
}
.agentUser__infoTable{
padding: 20px;
    width: 100%;
    border-spacing: 0px;
    margin-bottom: 20px;
}
.agentUser__infoLabel{
background-color: #5F0AFF;
    height: 70px;
    color: white;
}
.agentUser__infoLabel__item{
    text-align: center;
    vertical-align: middle;
}
.agentUser__infoValue{
height: 60px;
    font-size: 16px;
    color: #333;
}
.agentUser__infoValue--blue{
    background-color: #f2f7ff;
}
.agentUser__infoValue--white{
    background-color: #ffffff;
}
.agentUser__infoValue__item{
text-align: center;
    vertical-align: middle;
    cursor: pointer;
}
.agentUser__infoValue__item--red{
  color: red;
}
.agentUser__infoValue__item--blue{
  color: blue;
}
.listen_content{
  // width: 510px;
    min-height: 200px;
    max-height: 300px;
    margin: 20px 0;
    overflow: auto;
}
.listen_item{
  padding: 10px;
  background-color: #F2F7FF;
  border-radius: 4px;
  color: #333333;
  display:flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  .text{
    margin: 0 20px;
  }

}
.agentUser__button{
  display: inline-block;
  height: 32px;
  line-height: 32px;
  background: #5f0aff;
  border-radius: 16px;
  color: #fff;
  padding: 0 14px;
  cursor: pointer;
  font-size: 14px;
}
</style>
